import { StatelessComponent } from 'react'
import * as styles from 'styles/atoms/TransunionBadge.css'

const TransunionBadge: StatelessComponent = () => (
  <div className={ styles.transUnionItem }>
    <span>powered by</span>
    <img className={ styles.logo } src='/resources/images/partner-logos/trans-union.svg' />
  </div>
)

export default TransunionBadge
